import { STATUS_COLOR, PRIORITY_COLOR } from '../../lib/constants';

export function StatusBadge({ status }) {
  const color = STATUS_COLOR[status] || '#607080';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: '3px 10px', borderRadius: 20,
      background: color + '18', border: `1px solid ${color}40`,
      color, fontSize: 11, fontWeight: 700,
    }}>
      <span style={{ width: 5, height: 5, borderRadius: '50%', background: color }} />
      {status}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const color = PRIORITY_COLOR[priority] || '#607080';
  return (
    <span style={{
      padding: '2px 8px', borderRadius: 20,
      background: color + '18', border: `1px solid ${color}40`,
      color, fontSize: 10, fontWeight: 700,
    }}>
      {priority}
    </span>
  );
}

export function RoleBadge({ role }) {
  const colors = { Admin: '#00e5a0', Operator: '#5b9cf6', Viewer: '#b89de8' };
  const c = colors[role] || '#607080';
  return (
    <span style={{
      padding: '2px 10px', borderRadius: 20,
      background: c + '18', border: `1px solid ${c}40`,
      color: c, fontSize: 11, fontWeight: 700,
    }}>
      {role}
    </span>
  );
}
